import { render } from "./IcoBig.vue?vue&type=template&id=49f13fbe"
import script from "./IcoBig.vue?vue&type=script&lang=js"
export * from "./IcoBig.vue?vue&type=script&lang=js"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Form/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__